import { Controller } from "@hotwired/stimulus";
import { Target, TypedController, Value } from "@vytant/stimulus-decorators";

@TypedController
export default class extends Controller<HTMLDivElement> {
  @Target readonly legalLinksTarget!: HTMLUListElement;
  @Value(Boolean) readonly hideLegalLinksIfIframeValue: string;

  connect() {
    const isIframe = window.self !== window.top;
    if (isIframe && this.hideLegalLinksIfIframeValue) {
      this.hide();
    }
  }

  hide() {
    this.legalLinksTarget.classList.add("tw-hidden");
  }
}
